<div class="heatmap-wrapper">
    <div #heatmap></div>
</div>